const BhutanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110921)">
      <path
        d="M34.1421 34.1421C26.3317 41.9526 13.6684 41.9526 5.85785 34.1421C-1.95262 26.3317 -1.95262 13.6683 5.85785 5.85775C5.86066 5.85775 23.8311 0.547832 31.6417 8.3583C39.4522 16.1688 34.1475 34.1367 34.1421 34.1421Z"
        fill="#FFDA44"
      />
      <path
        d="M34.1417 34.1423C41.9522 26.3318 41.9522 13.6684 34.1417 5.85788C26.3312 -1.95267 13.668 -1.95259 5.85742 5.85788L34.1417 34.1423Z"
        fill="#D80027"
      />
      <path
        d="M25.2276 25.229C24.406 25.5517 23.4514 25.5175 22.6232 25.0527C21.1599 24.2314 20.6376 22.3725 21.459 20.909L21.2097 20.7692C23.7152 20.165 25.5689 17.8908 25.5364 15.2071C25.5162 13.5386 24.7707 12.0458 23.6045 11.0244L21.7785 12.8952C22.4688 13.4454 22.9164 14.2893 22.9279 15.2387C22.9482 16.9168 21.5996 18.2986 19.9215 18.3189L19.9251 18.6046C18.149 16.7369 15.2528 16.2687 12.9449 17.6387C11.5101 18.4906 10.5902 19.8825 10.2886 21.4032L12.8217 22.0493C12.953 21.1763 13.46 20.3668 14.2765 19.882C15.7195 19.0254 17.5904 19.5025 18.4471 20.9455L18.693 20.7996C17.9635 23.2714 19.0061 26.0138 21.3466 27.3275C22.8018 28.1443 24.4671 28.245 25.9349 27.7458L25.2276 25.229ZM19.9426 20.0576L19.9424 20.0577L19.9426 20.0576Z"
        fill="#FF9811"
      />
      <path
        d="M27.4053 13.545L25.9917 18.5896L21.7503 17.8064L19.0202 12.1787L11.6446 14.796L11.063 13.1569L9.1333 12.9192L10.5873 17.0168L15.663 15.7186L17.1054 19.7834L13.5967 24.9616L19.5511 30.0402L18.4224 31.3634L19.1814 33.1536L22.0031 29.8455L18.3411 26.0989L21.1401 22.8174L27.379 23.2669L28.8 15.5708L30.5103 15.8867L31.6813 14.3343L27.4053 13.545ZM19.9987 20.1357V20.1359V20.1357Z"
        fill="#FFEACF"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110921">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BhutanSvg;
